export default {
  'pages.platformSettings.title': 'プラットフォーム設定',
  'pages.platformSettings.tab.branding': 'ブランド',
  'pages.platformSettings.tab.llm': '既定モデル',
  'pages.platformSettings.tab.storage': '既定ストレージ',
  'pages.platformSettings.tab.quota': '利用上限',
  'pages.platformSettings.tab.features': 'プラットフォーム機能',
  'pages.platformSettings.tab.permissions': 'プラットフォーム権限',
  'pages.platformSettings.subtitle.branding':
    'プラットフォーム名、ロゴ、著作権表示を設定します。',
  'pages.platformSettings.subtitle.llm':
    'プラットフォームが既定で使用するモデルを選択します。',
  'pages.platformSettings.subtitle.storage':
    '新規アプリの既定ストレージ方針を設定します。',
  'pages.platformSettings.subtitle.quota':
    '全テナントに適用される既定の枠と上限を設定します。',
  'pages.platformSettings.subtitle.features':
    'プラットフォーム全体の機能をオン・オフします。',
  'pages.platformSettings.subtitle.permissions':
    'アカウントにプラットフォームロールを付与します。テナント内のロール設定はありません。',
  'pages.platformSettings.save': '保存',
  'pages.platformSettings.reset': 'リセット',
  'pages.platformSettings.saveSuccess': '設定を保存しました',
  'pages.platformSettings.saveFailed': '保存に失敗しました。再試行してください',
  'pages.platformSettings.loadFailed':
    'プラットフォーム設定の読み込みに失敗しました',
  'pages.platformSettings.retry': '再試行',
  'pages.platformSettings.zeroUnlimited': '0 は無制限',
  'pages.platformSettings.branding.title': 'プラットフォームブランド',
  'pages.platformSettings.branding.description':
    'ブランドはサインイン前のページを含む全ユーザーに適用されます。名前とロゴは現在のデプロイで使用中の値を表示します。フッターを空にすると各言語の既定値を使用します。',
  'pages.platformSettings.branding.platformName': 'プラットフォーム名',
  'pages.platformSettings.branding.platformNameExtra':
    'ヘッダーとブラウザのタイトルに表示されます',
  'pages.platformSettings.branding.platformNamePlaceholder': '例：珊瑚礁',
  'pages.platformSettings.branding.platformNameEn': '英語名',
  'pages.platformSettings.branding.logoLight': 'ライトテーマ用ロゴ',
  'pages.platformSettings.branding.logoDark': 'ダークテーマ用ロゴ',
  'pages.platformSettings.branding.favicon': 'ブラウザタブのアイコン',
  'pages.platformSettings.branding.footerCopyright': 'フッターの著作権表示',
  'pages.platformSettings.branding.logoHint':
    'PNG・JPG・SVG・WebP・ICO、5MB まで',
  'pages.platformSettings.branding.uploadFailed': 'アップロードに失敗しました',
  'pages.platformSettings.branding.upload': 'アップロード',
  'pages.platformSettings.branding.restoreDefault': '既定に戻す',
  'pages.platformSettings.llm.title': '既定モデル',
  'pages.platformSettings.llm.description':
    'モデルを指定していないテナントとアプリはこの既定モデルを使用します。候補はモデル管理で有効な組み込みモデルです。',
  'pages.platformSettings.llm.manageModels': 'モデル管理',
  'pages.platformSettings.llm.loadFailed':
    'モデル一覧の読み込みに失敗しました。保存済みの選択のみ表示します',
  'pages.platformSettings.llm.chatModel': '既定のチャットモデル',
  'pages.platformSettings.llm.embeddingModel': '既定の埋め込みモデル',
  'pages.platformSettings.llm.notSet': '未設定',
  'pages.platformSettings.llm.unavailableModel':
    '{ref}（無効または存在しません）',
  'pages.platformSettings.storage.title': '既定ストレージ',
  'pages.platformSettings.storage.description':
    '新規アプリはこの既定値でストレージ設定が作成されます。既存の設定は変わりません。',
  'pages.platformSettings.storage.autoProvision':
    'アプリ作成時にストレージを自動作成',
  'pages.platformSettings.storage.autoProvisionExtra':
    'オフの場合はアプリストレージで手動作成します',
  'pages.platformSettings.storage.accessMode': '既定のアクセスモード',
  'pages.platformSettings.storage.accessMode.private': '非公開',
  'pages.platformSettings.storage.accessMode.public_read': '公開読み取り',
  'pages.platformSettings.storage.accessMode.public_folder_only':
    '公開フォルダのみ',
  'pages.platformSettings.storage.usageEnabled': '既定で使用量を記録',
  'pages.platformSettings.quota.title': 'テナント利用上限',
  'pages.platformSettings.quota.description':
    '全テナントに適用される既定の上限です。プランや追加パックの割当は既定値に加算されます。',
  'pages.platformSettings.quota.defaultTenantTokenQuota':
    'テナント既定のトークン枠',
  'pages.platformSettings.quota.defaultTenantStorageQuotaGb':
    'テナント既定のストレージ枠',
  'pages.platformSettings.quota.maxMembersPerTenant':
    'テナントあたりの最大メンバー数',
  'pages.platformSettings.quota.maxInstalledAppsPerTenant':
    'テナントあたりのセルフサービスアプリ上限',
  'pages.platformSettings.quota.defaultQuotaExtra':
    '枠のないテナントはこの値から開始します。0 は既定枠なし',
  'pages.platformSettings.quota.maxInstalledAppsExtra':
    'マーケットで有効化した無料アプリのみ数えます（プランのアプリを除く）。0 は無制限',
  'pages.platformSettings.quota.unitPerson': '人',
  'pages.platformSettings.quota.unitApp': '個',
  'pages.platformSettings.features.title': 'プラットフォーム機能',
  'pages.platformSettings.features.aiAssistant': 'グローバル AI アシスタント',
  'pages.platformSettings.features.aiAssistantExtra':
    'オフにすると全ユーザーで AI アシスタントを非表示にします',
  'pages.platformSettings.permissions.user': 'アカウント',
  'pages.platformSettings.permissions.grantedAt': '付与日時',
  'pages.platformSettings.permissions.actions': '操作',
  'pages.platformSettings.permissions.revoke': '取り消す',
  'pages.platformSettings.permissions.userRequired':
    'アカウントを選択してください',
  'pages.platformSettings.permissions.userPlaceholder':
    '名前・ユーザー名・電話・メールで検索',
  'pages.platformSettings.readOnlyHint':
    '閲覧権限のみのため、プラットフォーム設定は変更できません',
  'pages.platformSettings.permissions.notice':
    '権限は「リソース＋閲覧/管理」をロールに付与し、ロールをアカウントに付与します。テナントとは無関係です。ロールと付与は YeeAuth で管理され、変更は最大 30 秒で反映されます。',
  'pages.platformSettings.permissions.roles': 'ロール',
  'pages.platformSettings.permissions.createRole': 'ロールを作成',
  'pages.platformSettings.permissions.builtin': '組み込み',
  'pages.platformSettings.permissions.rename': '名前を変更',
  'pages.platformSettings.permissions.deleteRole': '削除',
  'pages.platformSettings.permissions.deleteRoleConfirm':
    'ロール「{name}」を削除しますか？このロールのアカウントは権限を失います。',
  'pages.platformSettings.permissions.deleteRoleSuccess':
    'ロールを削除しました',
  'pages.platformSettings.permissions.tabPermissions': '権限',
  'pages.platformSettings.permissions.tabMembers': 'メンバー',
  'pages.platformSettings.permissions.adminLocked':
    'プラットフォーム管理者はすべての権限を持ち、変更できません',
  'pages.platformSettings.permissions.resource': 'リソース',
  'pages.platformSettings.permissions.action.read': '閲覧',
  'pages.platformSettings.permissions.action.manage': '管理',
  'pages.platformSettings.permissions.roleName': 'ロール名',
  'pages.platformSettings.permissions.roleNameRequired':
    'ロール名を入力してください',
  'pages.platformSettings.permissions.addMember': 'メンバーを追加',
  'pages.platformSettings.permissions.empty':
    'このロールにはメンバーがいません',
  'pages.platformSettings.permissions.revokeConfirm':
    '「{name}」を{role}から外しますか？',
  'pages.platformSettings.permissions.cannotRevokeSelf':
    '自分をプラットフォーム管理者から外すことはできません',
  'pages.platformSettings.permissions.grantSuccess': 'メンバーを追加しました',
  'pages.platformSettings.permissions.grantFailed': '追加に失敗しました',
  'pages.platformSettings.permissions.revokeSuccess': '外しました',
  'pages.platformSettings.permissions.loadFailed': '読み込みに失敗しました',
  'pages.noPlatformPermission.title': 'プラットフォーム権限がありません',
  'pages.noPlatformPermission.description':
    'このアカウントにはプラットフォームロールが付与されていません。管理者に権限を依頼し、再度サインインしてください。',
  'pages.noPlatformPermission.logout': 'サインアウト',
  'pages.platformSettings.permissions.group.applications': 'アプリ',
  'pages.platformSettings.permissions.group.commercial': '販売・マーケティング',
  'pages.platformSettings.permissions.group.capabilities': '基盤サービス',
  'pages.platformSettings.permissions.group.resources': '運用監視',
  'pages.platformSettings.permissions.group.management': 'プラットフォーム管理',
  'pages.platformSettings.permissions.group.settings': '設定',
  'pages.platformSettings.storage.accessMode.inherit':
    'ファイル管理の既定値（公開フォルダのみ）',
};
